<template>
    <div>
        <v-layout align-center justify-center v-show="questionSource==0">
            <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: center;">
                <v-card class="elevation-1 pa-3">
                    <v-card-text style="text-align: center">
                        <h3>{{$t("lang.exercise.quizQuestion")}}</h3>
                        <v-form ref="form" @keyup.enter.native="onSave">
                            <v-layout wrap>
                                <v-flex
                                        xs12
                                        sm12
                                        md8
                                        lg8
                                        xl8
                                        style="border:1px solid gray; border-radius:5px;padding:10px;max-height: 800px;overflow: scroll"
                                >
                                    <v-card-actions style="align-items:flex-end">
                                        <v-btn color="info" @click="fromLibary" style="margin-left:10px">
                                            {{ $t('lang.exercise.fromLibrary') }}
                                        </v-btn>
                                        <v-btn color="orange" dark @click="fromWareHouse" style="margin-left:10px">
                                            {{ $t('lang.exercise.fromWarehouse') }}
                                        </v-btn>
                                        <v-btn color="purple" dark @click="fromMatrix" style="margin-left:10px">
                                            Từ ma trận
                                        </v-btn>
                                    </v-card-actions>
                                    <table class="lstTable" v-if="attachs.length>0">
                                        <tr class="yoprimary">
                                            <td colspan="2">Danh sách tệp câu hỏi</td>
                                        </tr>
                                        <tr v-for="att in attachs" :key="att+att.attachId">
                                            <td style="text-align: left"><a
                                                    @click="viewAtt(att)">{{att.fileName}}</a></td>
                                            <td>
                                                <v-icon @click="deleteAtt(att)" color="red">delete
                                                </v-icon>
                                            </td>
                                        </tr>
                                    </table>
                                    <file-view
                                            :editable="true"
                                            accept=".pdf, image/*"
                                            :attachId="attachId"
                                            :attachType="attachType"
                                            @change="uploadNewFile"
                                    />
                                    <yolearn-question :exam-id="examId" type="review" id="viewYoclassQuestion"
                                                      ref="yolearn"/>
                                </v-flex>
                                <v-flex
                                        xs12
                                        sm12
                                        md4
                                        lg4
                                        xl4
                                        style="border:1px solid gray; border-radius:5px;padding:10px;max-height: 800px;overflow: auto"
                                >
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field append-icon="group" v-validate="'required'"
                                                          :label="$t('lang.exercise.name')"
                                                          v-model="exercise.name"
                                                          :disabled="exercise.questionId != null"
                                                          maxlength="200"
                                                          :data-vv-as="$t('lang.exercise.name')"
                                                          name="name"
                                                          :error-messages="errors.first('name')"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <!--v-text-field append-icon="code" v-validate="'required'"
                                                          :label="$t('lang.exercise.subject')"
                                                          v-model="exercise.subject"
                                                          maxlength="200"
                                                          :data-vv-as="$t('lang.exercise.subject')"
                                                          name="subject"
                                                          :error-messages="errors.first('subject')"/-->
                                            <v-textarea
                                                    label="Hướng dẫn làm bài"
                                                    v-model="exercise.guideline"
                                                    name="guideline"
                                                    maxlength="500"
                                                    :error-messages="errors.first('guideline')"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <!--v-flex xs12 sm6 md6 lg6 xl6 style="margin-right: 5px">
                                                        <v-datetime-picker :label="$t('lang.exercise.effectiveDate')"
                                                               locale="vi"
                                                               v-validate="'required'"
                                                               type="datetime-local"
                                                               :data-vv-as="$t('lang.exercise.effectiveDate')"
                                                               name="effectiveDate"
                                                               ref="effectiveDate"
                                                               v-model="exercise.effectiveDate"
                                                               :error-messages="errors.first('effectiveDate')"></v-datetime-picker>
                                        </v-flex-->
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <i-datepicker :label="$t('lang.exercise.dueDate')"
                                                          v-if="exercise.questionId != null && exercise.receivers!= null"
                                                          key="dueDateNo"
                                                          v-model="exercise.dueDate"
                                                          v-validate="'required|date_format:yyyy-MM-dd'"
                                                          :data-vv-as="$t('lang.exercise.dueDate')"
                                                          name="dueDateNo"
                                                          :error-messages="errors.first('dueDateNo')"
                                            />
                                            <i-datepicker :label="$t('lang.exercise.dueDate')"
                                                          v-model="exercise.dueDate"
                                                          v-else
                                                          key="dueDateSe"
                                                          v-validate="'required|date_format:yyyy-MM-dd|date_after_now'"
                                                          :data-vv-as="$t('lang.exercise.dueDate')"
                                                          name="dueDateSe"
                                                          :error-messages="errors.first('dueDateSe')"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 sm6 md12 lg12 xl12>
                                            <v-text-field append-icon="access_time" v-validate="'numeric'"
                                                          :label="$t('lang.exercise.questionTime')"
                                                          :data-vv-as="$t('lang.exercise.questionTime')"
                                                          maxlength="4"
                                                          v-model="exercise.questionTime"
                                                          name="questionTime"
                                                          :error-messages="errors.first('questionTime')"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-select append-icon="supervised_user_circle"
                                                      label="Cho phép học sinh"
                                                      height="40px"
                                                      :items="studentPermission"
                                                      item-text="name"
                                                      item-value="value"
                                                      chips
                                                      v-model="exercise.permission"
                                                      data-vv-as="Cho phép học sinh"
                                                      name="permission"
                                                      @change="refreshAnswerAtt()"
                                                      :error-messages="errors.first('permission')"/>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout v-if="viewAnswerAtt && exercise.source==0">
                                        <v-flex>
                                            <i-upload name="answerAttachId" v-validate="'required'"
                                                      v-model="exercise.answerAttachId" label="Lời giải"
                                                      @change="changeAnswerDetail"/>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                            <v-text-field
                                                    :label="$t('lang.exercise.numberOfQuiz')"
                                                    v-validate="'required|numeric|max_value:200|min_value:1'"
                                                    maxlength="3"
                                                    :data-vv-as="$t('lang.exercise.numberOfQuiz')"
                                                    v-model="numberOfQuiz"
                                                    name="numberOfQuiz"
                                                    :error-messages="errors.first('numberOfQuiz')"
                                            />
                                        </v-flex>
                                    </v-layout>
                                    <!--v-layout>
                                        <v-flex xs12 sm1 md6 lg6 xl6>
                                            <v-text-field append-icon="code" v-validate="'required|numeric'"
                                                          :label="$t('lang.exercise.markScale')"
                                                          maxlength="4"
                                                          height="40px"
                                                          v-model="exercise.markScale"
                                                          :data-vv-as="$t('lang.exercise.markScale')"
                                                          name="markScale"
                                                          :error-messages="errors.first('markScale')"/>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6 lg6 xl6 style="margin-left: 5px">
                                            <v-select append-icon="supervised_user_circle"
                                                      :label="$t('lang.exercise.receivers')"
                                                      height="40px"
                                                      :items="classMember"
                                                      item-text="fullName"
                                                      item-value="userId"
                                                      multiple
                                                      chips
                                                      v-model="receivers"
                                                      :data-vv-as="$t('lang.exercise.receivers')"
                                                      name="receivers"
                                                      :error-messages="errors.first('receivers')">
                                            </v-select>
                                        </v-flex>
                                    </v-layout-->
                                    <v-layout>
                                        <v-flex style="background-color: snow">
                                            <div style="height: 30px;line-height: 30px; border-top:1px dashed gray">ĐÁP
                                                ÁN
                                            </div>
                                            <!--div style="">
                                                <a href="/template/answer.xlsx">File template đáp án</a>
                                                <i-upload style="width: 100%"
                                                          :label="$t('lang.exercise.answerFile')"
                                                          accept=".xlsx"
                                                          input-type="button"
                                                          name="uploadAnswer"
                                                          :display-result="false"
                                                          v-model="uploadAnswer"
                                                />
                                            </div-->
                                            <a :class="getClassOfQuiz(item-1)"
                                               :id="'anchor'+(item-1)"
                                               :href="'#question'+(item-1)"
                                               v-for="item in parseInt(exercise.numberOfQuiz)"
                                               @click="selectAnswer(item-1)"
                                            >{{item}}:{{childExercise[item-1].answer}}</a>
                                            <v-text-field :label="getPlaceHolder()"
                                                          @keyup.enter.native.stop="nextQuestion"
                                                          v-model="currentAnswer" maxlength="1"/>

                                            <!--div
                                                    class="answerDetail"
                                                    :id="'question'+(item-1)"
                                                    v-for="item in parseInt(exercise.numberOfQuiz)"
                                                    :key="item"
                                            >
                                                <div class="answerHeader">Câu {{ item}}</div>

                                                <v-autocomplete
                                                        :label="$t('lang.exercise.answer')+ ' câu '+item"
                                                        v-validate.initial="'required'"
                                                        v-model="childExercise[item-1].answer"
                                                        :data-vv-as="$t('lang.exercise.answer')"
                                                        :name="'answer_'+item"
                                                        :error-messages="errors.first('answer_'+item)"
                                                        :items="answerOptions"
                                                />
                                                <v-text-field
                                                        flat
                                                        v-validate.initial="'required'"
                                                        :label="$t('lang.exercise.subject')+ ' câu '+item"
                                                        :data-vv-as="$t('lang.exercise.subject')"
                                                        :name="'subject_'+item"
                                                        :error-messages="errors.first('subject_'+item)"
                                                        v-model="childExercise[item-1].subjects"
                                                />
                                                <v-autocomplete
                                                        :label="$t('lang.exercise.hardLevel')+ ' câu '+item"
                                                        v-model="childExercise[item-1].hardLevel"
                                                        :name="'hardLevel_'+item"
                                                        :items="hardLevelItems"
                                                />
                                            </div-->
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="cancel" @click="cancel">
                            {{ $t('lang.common.cancel') }}
                        </v-btn>
                        <v-btn color="purple" dark @click="viewExamDetail" v-if="exercise.source==1">
                            Xem lời giải chi tiết
                        </v-btn>
                        <v-btn class="yoprimary" dark @click.once="onSave" v-if="$store.state.auth.user.role==4">
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn class="info" dark @click="onSend"
                               v-if="$store.state.auth.user.role==4 && (exercise.receivers == null || exercise.receivers == '')">
                            {{$t('lang.class.sendToStudent')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <question-in-store v-show="questionSource==1" :class-id="classId" @cancel="questionSource=0"
                           @save="saveYolearnQuestion"/>
        <question-in-bank v-show="questionSource==2" @cancel="questionSource=0" :class-id="classId"/>
        <matrix-page v-show="questionSource==3" @cancel="matrixCancel" :class-id="classId" @save="saveYolearnQuestion"
                     ref="matrixPage"/>
        <library-question v-model="showLibrary" exercise-type="6" @onSelect="selectQuestionFromLibrary"/>
        <send-to-member :class-id="classId" @send="onChangeReceiver" ref="sendDialog"/>
    </div>
</template>

<script>
    import {message} from "../../services";
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios";
    import IUpload from "../../components/form/Upload";
    import pdf from "vue-pdf";
    import FileView from "./fileView";
    import LibraryQuestion from "./libraryQuestion";
    import QuestionInStore from "./questionInStore";
    import QuestionInBank from "./questionInBank";
    import YolearnQuestion from "./YolearnQuestion";
    import {Validator} from "vee-validate";
    import moment from "moment";
    import SendToMember from "./sendToMember";
    import MatrixPage from "./matrix/matrixPage";

    export default {
        name: "quiz-create",
        components: {
            MatrixPage,
            SendToMember,
            YolearnQuestion,
            QuestionInBank,
            QuestionInStore,
            LibraryQuestion,
            pdf,
            IUpload,
            IDatepicker,
            FileView
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            },
            source: {
                type: Number,
                default: () => {
                    return 0;
                }
            }
        },

        mounted: function () {
            Validator.extend("dueDateAfter", {
                validate: (value, {otherValue}) => {
                    let mm = moment(value).hour(23).minute(59).second(59);
                    let valid = mm.isSameOrAfter(this.exercise.effectiveDate); // false
                    return {
                        valid: valid,
                        data: {
                            message: "Ngày hết hạn phải sau Ngày có hiệu lực"
                        }
                    };
                    ;
                },
                getMessage: (field, params, data) => {
                    return "Ngày đến hạn phải sau Ngày có hiệu lực";
                }
            });

        },

        data() {
            return {
                prepage: 'list',
                viewAnswerAtt: false,
                uploadAnswer: null,
                questionSource: 0,
                receivers: [],
                clazz: {},
                classMember: [],
                hardLevelItems: [1, 2, 3, 4, 5],
                answerOptions: ['A', 'B', 'C', 'D'],
                accept: ".pdf, image/*",
                numberOfQuiz: 0,
                fileName: "",
                numPages: 0,
                currentPage: 1,
                attachPath: "",
                fileType: "",
                childExercise: [],
                exercise: {
                    examId: null,
                    source: 0,
                    name: "",
                    subject: "",
                    question: null,
                    dueDate: new Date(),
                    effectiveDate: new Date(),
                    questionTime: 30,
                    markScale: 10,
                    content: "",
                    numberOfQuiz: 0,
                    attachId: null,
                    attachType: null
                },
                studentPermission: [
                    {name: "Chỉ xem điểm", value: 0},
                    {name: "Xem đáp án", value: 1},
                    {name: "Xem đáp án và lời giải chi tiết", value: 2},
                ],
                currentQuestion: 0,
                currentAnswer: null,
                examId: 0,
                showLibrary: false,
                subjects: [],
                grades: [],
                attachs: [],
                attachId: null,
                attachType: null,
                sendDialog: false,
                processing:false,
            };
        },

        watch: {
            numberOfQuiz: function (data) {
                if (isNaN(data)) {
                    this.exercise.numberOfQuiz = 0;
                    this.childExercise = [];
                    return;
                }
                this.exercise.numberOfQuiz = data;
                if (this.childExercise.length == data) {
                    //console.log(this.childExercise);
                    return;
                } else if (this.childExercise.length > data) {
                    this.childExercise.length = data;
                    //console.log(this.childExercise);
                } else {
                    let pushL = this.numberOfQuiz - this.childExercise.length;
                    for (let i = 0; i < pushL; i++) {
                        let q = {
                            answer: "",
                            subjects: "",
                            hardLevel: 1
                        };
                        this.childExercise.push(q);
                    }
                }
                //console.log(this.childExercise);
            },

            uploadAnswer: function (data) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/uploadFileAnswer?attachId=" +
                        data
                    )
                    .then(
                        data => {
                            if (data == null || data.status == 500 || data.length == 0) {
                                message.error("data is null or can't parse file");
                            } else {
                                this.numberOfQuiz = data.length;
                                this.childExercise = data;
                                message.success("Đã upload file đáp án thành công");
                                this.$refs.form.validate();
                            }
                        },
                        error => {
                            //console.log(error);
                            message.error("Không thể xử lý file, hãy kiểm tra lại định dạng, nội dung file");

                        }
                    );
            },

            receivers: function (data) {
                if (this.receivers[this.receivers.length - 1] == 0) {
                    if (this.receivers.length > 1) {
                        this.receivers = [0];
                    }
                } else {
                    for (let i = this.receivers.length - 1; i >= 0; i--) {
                        if (this.receivers[i] == 0) {
                            this.receivers.splice(i, 1);
                        }
                    }
                }
            }
        },

        created() {
            ////console.log(this.question);
            axios.post(process.env.VUE_APP_API_URL + "/class/getStudentOfClass?classId=" + this.classId).then(
                data => {
                    this.classMember = [{'fullName': "Tất cả", 'userId': 0}, ...data];
                    //console.log(this.classMember);
                },
                error => {
                    //console.log(error);
                }
            )
            if (this.source == null || this.source == undefined) {
                this.questionSource = 0;
            } else {
                this.questionSource = this.source;
            }
            if (this.question != null) {
                this.initFromQuestion(this.question);
            } else {
                this.exercise.questionId = null;
                this.exercise.name = "";
                this.exercise.subject = "";
                this.exercise.questionTime = 90;
                this.numberOfQuiz = 0;
                this.exercise.dueDate = null;
                this.exercise.effectiveDate = null;
                this.exercise.markScale = 10;
                this.exercise.question = null;
                this.exercise.attachId = null;
                this.exercise.attachType = null;
                this.exercise.permission = 0;
                this.viewAnswerAtt = false;
                this.receivers = [0];
                this.childExercise = [];
                //this.viewFile(null);
            }
            //console.log(this.exercise);
        },

        computed: {},

        methods: {
            getClassOfQuiz(item) {
                if (this.childExercise[item].answer == undefined || this.childExercise[item].answer == null || this.childExercise[item].answer == "") {
                    return "quizQuestion";
                } else {
                    return "quizQuestion yoprimary";
                }
            },

            getPlaceHolder: function () {
                return "Đáp án câu " + (this.currentQuestion + 1) + ". Ấn enter để chuyển sang câu kế tiếp ";
            },

            selectAnswer(item) {
                if (this.currentAnswer != "" && this.currentAnswer != null) {
                    this.currentAnswer = this.currentAnswer.toUpperCase();
                    if (this.currentAnswer != "A" && this.currentAnswer != "B" && this.currentAnswer != "C" && this.currentAnswer != "D") {
                        message.error("Đáp án chỉ có thể là A,B,C,D");
                        return;
                    }
                    this.childExercise[this.currentQuestion].answer = this.currentAnswer;
                }

                this.currentQuestion = item;
                this.currentAnswer = this.childExercise[this.currentQuestion].answer;
            },

            nextQuestion: function () {
                if (this.currentAnswer != "" && this.currentAnswer != null) {
                    this.currentAnswer = this.currentAnswer.toUpperCase();
                    if (this.currentAnswer != "A" && this.currentAnswer != "B" && this.currentAnswer != "C" && this.currentAnswer != "D") {
                        message.error("Đáp án chỉ có thể là A,B,C,D");
                        return;
                    }
                    this.childExercise[this.currentQuestion].answer = this.currentAnswer;
                }
                if (this.currentQuestion < this.exercise.numberOfQuiz - 1) {
                    this.currentQuestion++;
                } else {
                    this.currentQuestion = 0;
                }
                this.currentAnswer = this.childExercise[this.currentQuestion].answer;
            },

            initFromQuestion: function (question) {
                this.exercise = question;
                this.examId = question.examId;
                this.numberOfQuiz = question.numberOfQuiz;
                if (question.receivers != null && question.receivers != "") {
                    let arr = question.receivers.split(",");
                    this.receivers = [];
                    for (let i = 0; i < arr.length; i++) {
                        if (!isNaN(arr[i])) {
                            this.receivers.push(parseInt(arr[i]));
                        }
                    }
                }
                if (this.exercise.permission == 0 || this.exercise.permission == 1 || this.exercise.permission == null || this.exercise.permission == undefined) {
                    this.viewAnswerAtt = false;
                } else {
                    this.viewAnswerAtt = true;
                }
                this.childExercise = JSON.parse(question.question);
                if (question.attachs == undefined || question.attachs == null) {
                    this.attachs = [];
                } else {
                    this.attachs = JSON.parse(question.attachs);
                    if (this.attachs.length > 0) {
                        this.attachId = this.attachs[0].attachId;
                        this.attachType = this.attachs[0].type;
                    }
                }
                ////console.log(this.exercise);
            },

            onChangeReceiver: function (receivers) {
                this.receivers = receivers;
                this.save();
            },

            onSend: function () {
                this.$refs.sendDialog.show();
            },

            onSave: function () {
                this.receivers = [];
                this.save();
            },

            save() {
                //console.log(this.exercise);
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_form_fail"));
                        return;
                    }
                    ////console.log(this.class);
                    this.exercise.question = JSON.stringify(this.childExercise);
                    if (this.receivers != null && this.receivers.length > 0) {
                        let ids = this.receivers[0];
                        for (let i = 1; i < this.receivers.length; i++) {
                            ids += "," + this.receivers[i];
                        }
                        this.exercise.receivers = ids;
                    } else {
                        this.exercise.receivers = null;
                    }

                    this.exercise.attachs = JSON.stringify(this.attachs);
                    axios
                        .post(
                            process.env.VUE_APP_API_URL +
                            "/exercise/saveQuiz?classId=" +
                            this.classId,
                            this.exercise
                        )
                        .then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.cancel();
                                    /*
                                                                        if (
                                                                            this.exercise.questionId != null &&
                                                                            this.exercise.questionId != undefined
                                                                        ) {
                                                                            this.onCancel();
                                                                        } else {
                                                                            this.exercise = {
                                                                                name: "",
                                                                                subject: "",
                                                                                dueDate: new Date(),
                                                                                effectiveDate: new Date(),
                                                                                markScale: 10,
                                                                                content: ""
                                                                            };
                                                                            this.numberOfQuiz = 0;
                                                                            this.numPages = 0;
                                                                            this.attachPath = "";
                                                                        }
                                    */
                                } else {
                                    message.error(this.$t(data.description));
                                }
                            },
                            error => {
                                //console.log(error);
                            }
                        );
                });
            },

            saveYolearnQuestion: function (examination) {
                //console.log("----havm here---");
                this.exercise = {
                    examId: examination.exam_id,
                    source: 1,
                    name: examination.exam_name,
                    subject: examination.subject,
                    question: null,
                    dueDate: new Date(),
                    effectiveDate: new Date(),
                    questionTime: examination.test_duration,
                    markScale: examination.scale_of_points,
                    content: "",
                    numberOfQuiz: examination.exam_detail.length,
                    attachId: null,
                    attachType: null,
                }
                this.examId = examination.exam_id;
                this.numberOfQuiz = this.exercise.numberOfQuiz;
                this.questionSource = 0;
                this.childExercise = [];
                ////console.log(examination);
                for (let i = 0; i < examination.exam_detail.length; i++) {
                    let q = {
                        answer: "",
                        subjects: examination.exam_detail[i].chapter,
                        hardLevel: parseInt(examination.exam_detail[i].level)
                    };
                    for (let j = 0; j < examination.exam_detail[i].answer.length; j++) {
                        if (examination.exam_detail[i].answer[j].answer_id == examination.exam_detail[i].answer_correct) {
                            switch (j) {
                                case 0:
                                    q.answer = 'A';
                                    break;
                                case 1:
                                    q.answer = 'B';
                                    break;
                                case 2:
                                    q.answer = 'C';
                                    break;
                                case 3:
                                    q.answer = 'D';
                                    break;
                            }
                            break;
                        }
                    }
                    this.childExercise.push(q);
                }
                ////console.log(this.$refs);
                this.$refs.yolearn.previewExam();
                this.questionSource = 0
            },

            viewExamDetail() {
                this.$refs.yolearn.viewAnswerDetail();
            },


            fromLocal: function () {
                this.openFileDialog();
            },

            fromLibary: function () {
                this.showLibrary = true;
            },

            fromWareHouse: function () {
                this.questionSource = 1;
            },

            fromMatrix: function () {
                this.prepage = "detail";
                this.questionSource = 3;
                this.$refs.matrixPage.matrixTab = 1;
                this.$refs.matrixPage.getSavedExam();
            },

            matrixCancel() {
                //console.log(this.prepage);
                if (this.prepage == "detail") {
                    this.questionSource = 0;
                } else {
                    this.cancel();
                }
            },

            selectQuestionFromLibrary: function (libQuestion) {
                libQuestion.questionId = null;
                libQuestion.status = 0;
                libQuestion.receivers = null;
                this.initFromQuestion(libQuestion);
            },

            cancel: function () {
                this.$emit("onCancelCreate");
            },

            viewFile: function (attachId) {
                if (attachId == undefined || attachId == null) {
                    this.attachPath = null;
                    return;
                }
                this.attachPath = pdf.createLoadingTask(
                    process.env.VUE_APP_API_URL + "/download/attach/" + attachId
                );
                //console.log("--- attach path ---");
                //console.log(this.attachPath);
                this.attachPath.then(pdf => {
                    this.currentPage = 1;
                    this.numPages = pdf.numPages;
                    //console.log("--- numpages ---");
                    //console.log(this.numPages);
                });
            },

            viewAtt: function (att) {
                //console.log(att);
                this.attachType = att.type;
                this.attachId = att.attachId;
            },

            deleteAtt: function (att) {
                for (let i = 0; i < this.attachs.length; i++) {
                    if (this.attachs[i].attachId == att.attachId) {
                        this.attachs.splice(i, 1);
                        break;
                    }
                }
                if (this.attachId == att.attachId) {
                    //console.log("sdfsdf");
                    if (this.attachs.length > 0) {
                        this.attachType = this.attachs[0].type;
                        this.attachId = this.attachs[0].attachId;
                    } else {
                        this.attachType = null;
                        this.attachId = null;
                    }
                }
            },


            changeAnswerDetail(data) {
                this.exercise.answerAttachId = data.id;
                this.exercise.answerAttachType = data.type;
            },

            uploadNewFile: function (data) {
                this.exercise.attachId = data.id;
                this.exercise.attachType = data.type;
                let md = {
                    url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                    attachId: data.id,
                    type: data.type,
                    fileName: data.fileName
                }
                this.attachId = data.id;
                this.attachType = data.type;
                if (this.attachs == null) {
                    this.attachs = [md];
                } else {
                    this.attachs.push(md);
                }
                //console.log(this.attachs);
            },

            refreshAnswerAtt() {
                if (this.exercise.permission == 0 || this.exercise.permission == 1) {
                    this.viewAnswerAtt = false;
                } else {
                    this.viewAnswerAtt = true;
                }
            },
        }
    };
</script>

